import { parse, format } from 'url'

export const hookAllImageUrl = document => {
  const images = document.querySelectorAll('img')
  console.dir(images)
  Array.from(images, image => {
    image.src = imageUrlHook(image.src)
  })
}

export const imageUrlHook = url => {
  const urlInfo = parse(url, true)
  if (urlInfo.host === 'ws1.sinaimg.cn') {
    urlInfo.host = 'ww1.sinaimg.cn'
  }
  return format(urlInfo)
}
